import React, { FC, useCallback, useContext, useEffect, useState } from 'react'
import styles from '../../styles'
import { Grid } from '@mui/material'
import { FormattedMessage } from 'react-intl'
import { makeStyles } from 'tss-react/mui'
import PriseRDV from './components/PriseRDV'
import { SelectionPaneContext } from '../../components/selectionPane/components/SelectionPaneContext'
import { RefusRDVEnum } from './enums/refusRDVEnum'
import PriseRdvIndisponible from './components/PriseRdvIndisponible'
import PriseRdvTelephone from './components/PriseRdvTelephone'
import { SnackBarContext } from '../../components/snackBar/context/SnackBarContext'
import errorCatcher from '../../utils/errorCatcher'
import { GET_VISITES_RESIDENCE } from './utils/calendrierVisiteConstants'
import { offresVisitesResidence } from './api/visitesApi'
import { VisitesOffreModel } from '../offre/types/OffreModel'
import Loader from '../../components/loader/Loader'

const PlanificationVisite: FC = () => {
	const { classes, cx } = useStyles()
	const { currentOffer, currentClient } = useContext(SelectionPaneContext)
	const { displaySnackBar } = useContext(SnackBarContext)

	const [refusRDV, setRefusRDV] = useState<RefusRDVEnum | null>(null)
	const [priseRDVModal, setPriseRDVModal] = useState<boolean>(false)
	const [RDVTelephoneModal, setRDVTelephoneModal] = useState<boolean>(false)
	const [visites, setVisites] = useState<VisitesOffreModel[]>()
	const [loading, setLoading] = useState(false)

	const titleStyle = cx(
		classes.title2,
		classes.titleContainer
	)

	const gestionPopin = useCallback((visites: VisitesOffreModel[]) => {
		// L'utilisateur a déjà un RDV pour cette currentOffer
		const dejaRDVOffre = visites.some((visite) => visite.lotVisite === currentOffer?.idLot)
		// Nombre de rendez-vous dans la résidence de l'currentOffer
		const rdvMemeResidence = visites.filter((visite) => visite.residenceVisite === currentOffer?.residence.identifiantCRM).length > 1
		if (dejaRDVOffre) {
			setRefusRDV(RefusRDVEnum.DEJA_RDV)
		} else if (rdvMemeResidence) {
			setRefusRDV(RefusRDVEnum.MEME_RESIDENCE)
		} else {
			setPriseRDVModal(true)
			setRefusRDV(null)
		}
	}, [currentOffer])

	useEffect(() => {
		if (!!currentOffer) {
			// Si le RDV se prend que par téléphone, on compose le numéro
			if (currentOffer.residence.doitTelephonerPourRDV) {
				setRDVTelephoneModal(true)
			} else {
				if (!visites) {
					setLoading(true)
					offresVisitesResidence(currentClient?.id)
						.then((response: any) => {
							setVisites(response.visites)
							gestionPopin(response.visites)
						})
						.catch((error) => displaySnackBar(errorCatcher(error, GET_VISITES_RESIDENCE)))
						.finally(() => setLoading(false))
				} else {
					gestionPopin(visites)
				}
			}
		}
	}, [currentClient, currentOffer, displaySnackBar, gestionPopin, visites])

	return (
		<Grid container item className={classes.planificationContainer}>
			<Grid container item spacing="20px">
				<Grid container item>
					<span className={titleStyle}>
						<FormattedMessage
							id="planificationVisite.title"
							defaultMessage="Planification de la visite"
							description="Planification de la visite"
						/>
					</span>
				</Grid>
				<Grid container item>
					{loading ? <Loader /> :
						<Grid>
							{!!currentOffer && priseRDVModal && <PriseRDV offre={currentOffer} />}
							{refusRDV !== null && <PriseRdvIndisponible refusRDV={refusRDV} />}
							{!!currentOffer && RDVTelephoneModal && <PriseRdvTelephone telephone={currentOffer.residence.telephonePourRDV} />}
						</Grid>
					}
				</Grid>
			</Grid>
		</Grid>
	)
}

const useStyles = makeStyles()((theme) => ({
	...styles(theme),
	planificationContainer: {
		padding: '0px 20px'
	},
	titleContainer: {
		padding: 16
	}
}))

export default PlanificationVisite